export const iconFontAwesomeConstructionPenRuler = (
	<i className="fa-solid fa-pen-ruler"></i>
);
